<template>
    <v-row tag="dl" class="data-list" :style="style">
        <template v-if="dataList.length">
            <v-col tag="li" v-for="({ term, description, cols = 12, isPreLine = false }, i) in dataList" :key="`description-${i}`" :cols="cols" class="py-0">
                <dt :class="{ isPreLine }">{{ term }}</dt>
                <dd :class="{ isPreLine }">{{ description }}</dd>
            </v-col>
        </template>
        <template v-else-if="!disableNoneMessage">
            <v-col tag="li" cols="12" class="py-0">
                자료가 없습니다.
            </v-col>
        </template>
        <slot />
    </v-row>
</template>

<script>
export default {
    props: {
        dataList: Array,
        isOnList: { type: Boolean, default: false },
        disableNoneMessage: { type: Boolean, default: false },
    },
    computed: {
        style() {
            if (this.isOnList) return "font-size:0.9rem;line-height:2;";
            else return "font-size:1rem;line-height:2.5;";
        },
    },
};
</script>

<style lang="scss" scoped>
.data-list {
    line-height: 2;
    li {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    dt {
        color: hsl(0, 0, 30%);
        font-weight: 500;
        width: 6rem;
    }
    dd {
        color: grey;
        width: calc(100% - 6rem);
    }

    .isPreLine {
        white-space: pre-line;
        align-self: flex-start;
    }
}
</style>
